import { Routes, Route } from "react-router-dom";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import { MembersLayout } from "@/components/layout/MembersLayout";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { ProtectedRoute } from "@/components/auth";
import { NotFoundPage, LoginPage, SignupPage, MagicLinkPage } from "@/pages";
import { AdminRoutes } from "@/routes/AdminRoutes";
import { memberRoutes } from "@/routes/MemberRoutes";
import "./index.css";

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Auth pages — no auth required */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/auth/magic" element={<MagicLinkPage />} />
        </Route>

        {/* Protected pages — member nav wraps both member and admin sections */}
        <Route
          element={
            <ProtectedRoute>
              <MembersLayout />
            </ProtectedRoute>
          }
        >
          {memberRoutes()}
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Route>

        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}

export default App;
